import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDkWPyjEfuGgManWA5lUeiTYfbweulE4fY",
  authDomain: "scalesmanweb.firebaseapp.com",
  projectId: "scalesmanweb",
  storageBucket: "scalesmanweb.firebasestorage.app",
  messagingSenderId: "634998037437",
  appId: "1:634998037437:web:4d0d3d0ef9e2e530a190d4",
  measurementId: "G-KTY8EVHYFP"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

export default app;